const TAB_ID = sessionStorage.getItem("tabId") || crypto.randomUUID();
sessionStorage.setItem("tabId", TAB_ID);

const channel = new BroadcastChannel("tab-manager");

function broadcast(type, payload) {
  channel.postMessage({ type, payload });
}

function listen(handler) {
  channel.onmessage = (e) => handler(e.data);
}

export default {
  id: TAB_ID,
  broadcast,
  listen,
};
